// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Wge8Q{height:fit-content;overflow-y:auto;touch-action:pan-y;flex:1;position:relative}.Wge8Q.Mx3UO{display:flex;flex-direction:column;min-height:0;height:auto}.Unq0y{padding-inline:16px}.cP4Fs{text-align:center}.cP4Fs.vGBG0{text-align:start}.cP4Fs.Unq0y{padding-inline:16px}.XUyCy{text-align:center;display:flex;flex-direction:column;gap:8px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `Wge8Q`,
	"fillHeight": `Mx3UO`,
	"mGutter": `Unq0y`,
	"header": `cP4Fs`,
	"startAligned": `vGBG0`,
	"footer": `XUyCy`
};
export default ___CSS_LOADER_EXPORT___;
